import { z } from "zod";

export const FigmaFileDownloadScope = z.object({
  styles: z.boolean(),
  components: z.boolean(),
  componentSets: z.boolean(),
  currentVersion: z.literal("__latest__").nullable(),
  publishedVersion: z.string().nullable(),
  downloadChunkSize: z.number().optional(),
  maxFileDepth: z.number().optional(),
});

export const FigmaFileAccessData = z.object({
  accessToken: z.string(),
  accessTokenType: z.enum(["OAuth2", "PAT"]).default("OAuth2"),
});

export type FigmaFileDownloadScope = z.infer<typeof FigmaFileDownloadScope>;
export type FigmaFileAccessData = z.infer<typeof FigmaFileAccessData>;
